import { Icon, Typography } from '@design-system/index';
import './StatsCard.scss';
import { StatsArrowDown, StatsArrowUp } from '@assets/images/icons';
import Skeleton from 'react-loading-skeleton';

type StatsCardProps = { 
    title?: string;
    icon?: React.ReactNode;
    badge?: 'year' | 'month'
    direction?: 'up' | 'down' | 'neutral'
    value?: string | number
    subValue?: string | number
    subTitle?: string
    light?: boolean
    loading?: boolean
};

export const StatsCard: React.FC<StatsCardProps> = ({ title, badge, value, direction, subValue, subTitle, icon, light, loading }) => {
    return (
        <div className={`stats-card ${light ? 'light' : ''}`}>
            {title && (
                <div className="stats-card-header">
                    <Typography flex color="secondary" intrinsic="h3">
                        {icon && <Icon icon={icon} color="secondary" size={20} />}
                        {title}
                    </Typography>
                    {badge && (
                        <div className={`stats-card-header-badge ${badge}`}>
                            {badge === 'year' ? <>Année</> : <>Mois</>}
                        </div>
                        )}
                </div>
            )}
            <div className="stats-card-content">
                {loading ? <Skeleton count={1} circle={false} baseColor="#E6E3EF" highlightColor="#F8F7FA" height={36} /> : (
                    <Typography variant="number" color="secondary" intrinsic="p">
                        {value}
                    </Typography>
                )}
                {subTitle && (
                    <div className="stats-card-content-sub">
                        <Typography variant="p3" color="grey1" intrinsic="p">{subTitle}</Typography>
                        {subValue !== undefined && (
                            loading ? <Skeleton count={1} circle={false} baseColor="#E6E3EF" highlightColor="#F8F7FA" style={{marginTop: 2}} height={16} width={60} /> : (
                            <Typography color="secondary" intrinsic="p" flex className="stats-card-content-sub-value">
                                {direction === 'up' && <Icon icon={<StatsArrowUp />} color="secondary" size={10} />}
                                {direction === 'down' && <Icon icon={<StatsArrowDown />} color="secondary" size={10} />}
                                {direction !== 'neutral' && subValue}
                            </Typography>
                            )
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
